import { useEffect } from "react";
import { env } from "../config/env";
import { SiteFooter } from "../components/SiteFooter";
import { useI18n } from "../i18n/useI18n";
import type { UiKey } from "../i18n/ui";

type DocKind = "how" | "privacy" | "terms";

const TITLE_KEY: Record<DocKind, UiKey> = {
  how: "doc.how.title",
  privacy: "doc.privacy.title",
  terms: "doc.terms.title",
};

const BODY_KEY: Record<DocKind, UiKey> = {
  how: "doc.how.body",
  privacy: "doc.privacy.body",
  terms: "doc.terms.body",
};

export function DocPage({ kind }: { kind: DocKind }) {
  const { t } = useI18n();
  useEffect(() => {
    const title = `${t(TITLE_KEY[kind])} · ${env.appName}`;
    document.title = title;
  }, [kind, t]);
  const body = t(BODY_KEY[kind]);
  const paragraphs = body.split(/\n\n+/).filter(Boolean);

  return (
    <div className="doc-page">
      <header className="doc-page__head">
        <h1>{t(TITLE_KEY[kind])}</h1>
      </header>
      <article className="doc-page__article">
        {paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </article>
      <SiteFooter t={t} />
      <style>{`
        .doc-page {
          max-width: 42rem;
          margin: 0 auto;
          padding: 2rem clamp(0.85rem, 4vw, 1.35rem) 4rem;
        }
        .doc-page__head {
          margin-bottom: 1.5rem;
        }
        .doc-page__head h1 {
          font-size: 1.5rem;
          margin: 0;
          line-height: 1.25;
        }
        .doc-page__article p {
          margin: 0 0 1rem;
          line-height: 1.6;
          color: var(--text);
        }
        .doc-page__article p:last-child {
          margin-bottom: 0;
        }
      `}</style>
    </div>
  );
}
